export default __webpack_public_path__ + "static/web-analytics-light-mode-8c5bfb8efe73c668e6d2ff7af088cafa.png";